import { LogList } from "../../engine/logger/LogList";
import { Container } from "../../ui/containers/Container";
import { Modal } from "../../ui/containers/Modal";
import { Panel } from "../../ui/panels/Panel";
import { RDisplay } from "../../ui/RotDisplay";
import { Scene } from "../../ui/scene";
import { createElement } from "../../ui/ui";
import { initializeState, gameData } from "../GameManager";
import { MapUI } from "../../ui/map/MapUI";
import { TileContents } from "../ui/info/TileContents";
import { VH, VW } from "../../tiles";
import { SpellWand } from "../ui/info/SpellWand";
import { HealthBar } from "../ui/info/stats/HealthBar";
import { HungerBar } from "../ui/info/stats/HungerBar";
import { InventoryView } from "../ui/inventory/InventoryView";
import { SpellBookView } from "../ui/book/SpellBookView";
import { CoinInfo } from "../ui/info/CoinInfo";
import { AudioToggle } from "../ui/AudioToggle";
import { SoundSystem } from "../../sounds";
import { HelpCallToAction } from "../ui/info/HelpCallToAction";
export class GameScene extends Scene {
  ui = createElement(
    Container,
    { x: 0, y: 0, w: VW, h: VH },
    {
      children: [
        createElement(HealthBar, {
          x: 0,
          w: VW,
          y: VH - 7,
          h: 1,
        }),
        createElement(HungerBar, { x: 0, w: VW, y: VH - 7, h: 1 }),
        createElement(CoinInfo, { x: 24, w: 30, y: 0, h: 1 }),
        createElement(MapUI, { x: 20, w: 40, y: 1, h: VH - 8 }),
        createElement(
          Panel,
          { x: -1, y: VH - 6, w: VW + 2, h: 7 },
          {
            children: [
              createElement(TileContents, { x: 0, y: 0, w: VW, h: 5 }),
            ],
          }
        ),
        createElement(InventoryView, { x: 0, w: 18, y: 0, h: VH - 6 }),
        createElement(SpellBookView, { x: VW - 18, w: 18, y: 0, h: VH - 6 }),
        createElement(SpellWand, { x: 0, y: VH - 7, w: VW, h: 1 }),
        createElement(LogList, { x: 0, y: VH - 6, w: VW, h: 1 }),
        createElement(AudioToggle, { x: VW - 7, y: VH - 1, w: 7, h: 1 }),
        createElement(HelpCallToAction, { x: VW - 6, y: VH - 2, w: 6, h: 1 }),
        createElement(Modal, { x: 0, y: 0, w: VW, h: VH }),
      ],
    }
  );

  constructor() {
    super();
    initializeState();
    SoundSystem.load();
  }

  update(display: RDisplay, elapsed: number) {
    gameData.gibs.forEach((p) => p.update(elapsed));
    gameData.particles.forEach((p) => p.update(elapsed));
  }
}
